import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import StartIcon from '@mui/icons-material/Start'
import MosSmartDialog from '../MosSmartDialog'
import createDialogTitle from '../../../../generic/utilities/dialogUtil'
import { useSmartTranslation } from '../../../../generic/hooks/useSmartTranslation'
import BatchStartModeCards from './BatchStartModeCards'
import { JOB_START_MODE } from '../../FabricationOrderJobReference/PlannedJobs/utils/jobStatus'

/**
 * Historia 120 — Bloque 11 (Jupiter, paquete P5), `features/S116-previsualizacion-y-modo-jupiter.feature`.
 *
 * D-I6/RN25/S120: ONE mode question for the WHOLE batch, asked exactly once per gesture -- never
 * once per job (that would be the individual dialog's own question, repeated N times). The caller
 * (`PlannedJobListWidget`) decides WHETHER to open this at all: RN27/S122 says a batch with no
 * `managePreparation` job asks nothing, so this component is simply never mounted open in that case
 * -- it carries no such gate itself.
 *
 * S120: shares `BatchStartModeCards` with the individual start dialog (`JobStatusChangeDialog`) --
 * literally the same component, not a lookalike -- with PREPARATION preselected.
 *
 * S123: cancelling asks the caller to close this dialog (`onCancel`) and sends NOTHING -- no request
 * of any kind is built or fired from here. The caller is expected to keep the preview dialog it came
 * from mounted/open underneath (never unmounted across this round trip), so the operator's earlier
 * selection survives untouched -- this component holds no memory of that selection itself.
 */
const BatchStartModeDialog = ({ open, onCancel, onConfirm }) => {
  const { t_ } = useSmartTranslation()

  // D-I6: PREPARATION comes preselected, same rule as the individual dialog. Reset on every open so
  // a previous gesture's choice never leaks into the next one.
  const [selectedMode, setSelectedMode] = useState(JOB_START_MODE.PREPARATION)
  useEffect(() => {
    if (open) setSelectedMode(JOB_START_MODE.PREPARATION)
  }, [open])

  return (
    <MosSmartDialog
      title={createDialogTitle({ color: 'primary', title: t_('How do you want to start these jobs?'), icon: StartIcon })}
      setOpen={open}
      cancelCallback={onCancel}
      acceptCallback={() => onConfirm(selectedMode)}
    >
      <BatchStartModeCards value={selectedMode} onChange={setSelectedMode} legendId='batch-start-mode-label' />
    </MosSmartDialog>
  )
}

BatchStartModeDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
}

export default BatchStartModeDialog
